import React, { useState } from "react";
import styles from "./Header.module.css"; // CSS Module
import {
  Facebook,
  Instagram,
  Linkedin,
  Twitter,
  Mail,
  Phone,
  MapPin,
  Clock,
  Award,
  Heart,
  Users,
  Target
} from "lucide-react";
import { Navigate, useNavigate } from "react-router-dom";

const Header = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <header className={styles.redechHeader}>
      <div className={styles.inner}>
        <div className={styles.logo}>
          <div className={styles.logoBox}>
            <span className={styles.logoText}>RD</span>
          </div>
          <span className={styles.brandName}>Redech</span>
        </div>

        <nav className={`${styles.nav} ${open ? styles.open : ""}`}>
          <a
            className={styles.contactText}
            href="#features-section"
            onClick={(e) => {
              e.preventDefault();
              const section = document.getElementById("features-section");
              section?.scrollIntoView({ behavior: "smooth" });
              setOpen(false); // fecha menu mobile
            }}
          >
            Funcionalidades
          </a>

          <a
            className={styles.contactText}
            href="#about-section"
            onClick={(e) => {
              e.preventDefault();
              const section = document.getElementById("about-section");
              section?.scrollIntoView({ behavior: "smooth" });
              setOpen(false);
            }}
          >
            Sobre nós
          </a>

          <a
            className={styles.contactText}
            href="#contact"
            onClick={(e) => {
              e.preventDefault();
              const section = document.getElementById("contact-section");
              section?.scrollIntoView({ behavior: "smooth" });
              setOpen(false);
            }}
          >
            Contato
          </a>
        </nav>

        <div className={styles.contactLogin}>
          <div className={styles.contacts}>
            <div className={styles.contactItems}>
              <Phone style={{ color: 'hsl(210 40% 98% / 0.6)' }} size={16} />
              <a className={styles.contactItem}>
                (47) 98813-6845
              </a>
            </div>

            <div className={styles.contactItems}>
              <Mail style={{ color: 'hsl(210 40% 98% / 0.6)' }} size={16} />
              <a href="mailto:contato@redech.com.br" className={styles.contactItem}>
                contato@redech.com.br
              </a>
            </div>

          </div>
          <button
            onClick={() => navigate("/login")}
            className={styles.loginBtn}
          >
            Login
          </button>
        </div>

        <button
          className={styles.menuToggle}
          aria-label="Menu"
          onClick={() => setOpen((o) => !o)}
        >
          {open ? (
            <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true">
              <path
                d="M6 18L18 6M6 6l12 12"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
              />
            </svg>
          ) : (
            <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true">
              <path
                d="M4 6h16M4 12h16M4 18h16"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
              />
            </svg>
          )}
        </button>
      </div>

      {open && (
        <div className={styles.mobileMenu}>
          <div className={styles.mobileLinks}>
            <a
              href="#features-section"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById("features-section")?.scrollIntoView({ behavior: "smooth" });
                setOpen(false);
              }}
            >
              Funcionalidades
            </a>
          </div>
          <div className={styles.mobileLinks}>
            <a
              href="#about-section"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById("about-section")?.scrollIntoView({ behavior: "smooth" });
                setOpen(false);
              }}
            >
              Sobre Nós
            </a>
          </div>
          <div className={styles.mobileLinks}>
            <a
              href="#contact-section"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById("contact-section")?.scrollIntoView({ behavior: "smooth" });
                setOpen(false);
              }}
            >
              Contato
            </a>
          </div>

          <div className={styles.mobileContacts}>
            <a href="tel:+5547984721181">(47) 98472-1181</a>
            <a href="mailto:contato@redech.com.br">contato@redech.com.br</a>
            <button  onClick={() => navigate("/login")} className={`${styles.loginBtn} ${styles.mobileLogin}`}>
              Login
            </button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
